import http from "./http";
import commonHttp from "./commonHttp";

/**
 * 启动云台控制
 * @param data 云台控制参数对象
 * @param data.accessToken // 授权过程获取的access_token，一般一周过期
 * @param data.speed // 云台速度：0-慢，1-适中，2-快，海康设备参数不可为0
 * @param data.direction // 操作命令：0-上，1-下，2-左，3-右，4-左上，5-左下，6-右上，7-右下，8-物理放大，9-物理缩小，10-调整近焦距，11-调整远焦距，16-自动控制
 * @param data.channelNo // 通道号
 * @param data.deviceSerial // 设备序列号,存在英文字母的设备序列号，字母需为大写

 * @returns 返回启动云台控制请求的结果
 */
export function ptzStart(param) {
  return http.post(
    `/api/lapp/device/ptz/start?accessToken=${param.accessToken}&deviceSerial=${param.deviceSerial}&channelNo=${param.channelNo}&direction=${param.direction}&speed=${param.speed}`
  );
}
/**
 * 停止云台控制
 * 建议停止云台接口带方向参数。
 * @param data 云台停止请求的数据
 * @param data.accessToken // 授权过程获取的access_token，一般一周过期
 * @param data.direction // 操作命令：0-上，1-下，2-左，3-右，4-左上，5-左下，6-右上，7-右下，8-放大，9-缩小，10-近焦距，11-远焦距，16-自动控制
 * @param data.channelNo // 通道号
 * @param data.deviceSerial // 设备序列号,存在英文字母的设备序列号，字母需为大写
 * @returns 返回停止云台控制的响应结果
 */
export function ptzStop(param) {
  return http.post(
    `/api/lapp/device/ptz/stop?accessToken=${param.accessToken}&deviceSerial=${param.deviceSerial}&channelNo=${param.channelNo}&direction=${param.direction}&speed=${param.speed}`
  );
}
/**
 * 获取设备能力集
 * @param data 云台停止请求的数据
 * @param data.accessToken // 授权过程获取的access_token，一般一周过期
 * @param data.deviceSerial // 设备序列号,存在英文字母的设备序列号，字母需为大写
 * @returns 返回获取设备能力集的响应结果
 */
export function ptzCapacity(param) {
  return http.post(
    `/api/lapp/device/capacity?accessToken=${param.accessToken}&deviceSerial=${param.deviceSerial}`
  );
}

/**
 * 萤石云获取token
 * @param data 请求的参数
 * @param data.appKey // 授权过程获取的access_token，一般一周过期
 * @param data.appSecret // 设备序列号,存在英文字母的设备序列号，字母需为大写
 * @returns 返回获取设备能力集的响应结果
 */
export function yingshiToken(data) {
  return commonHttp.post(`/app/yingshiToken`, data, {
    headers: {
      Authorization: localStorage.getItem("token"),
    },
  });
}

/**
 * 萤石获取拉流地址
 * @param data 请求的参数
 * @param data.appKey // 授权过程获取的access_token，一般一周过期
 * @param data.appSecret // 设备序列号,存在英文字母的设备序列号，字母需为大写
 * @param data.deviceSerial // 设备序列号,存在英文字母的设备序列号，字母需为大写
 * @param data.channelNo // 通道号
 * @returns 返回获取设备能力集的响应结果
 */
export function getAddress(data) {
  return commonHttp.post(`/app/getAddress`, data, {
    headers: {
      Authorization: localStorage.getItem("token"),
    },
  });
}

/**
 * 获取摄像头列表
 * @param data 请求的参数
 * @param data.diyId //
 * @returns 返回获取设备能力集的响应结果
 */
export function cameraList(data) {
  return commonHttp.post(`/app/cameraList`, data, {
    headers: {
      Authorization: localStorage.getItem("token"),
    },
  });
}

/**
 * 获取用户权限字符集
 * @param {String} userId 用户ID
 */
export function getRoleByUserId(userId) {
  return commonHttp.get(
    `/app/getRoleByUserId/${userId}`,
    {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    }
  );
}

const api = {
  ptzStart,
  ptzStop,
  ptzCapacity,
  yingshiToken,
  getAddress,
  cameraList,
  getRoleByUserId,
};

export default api;
